<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t('views.secure.about.Title') }}</span>
          </div>
          <div class="ui grid main_container">
            <div class="sixteen wide column" style="padding:80px 0px 50px">
              <div style="text-align: center">
                <div class="ui large image">
                  <img src="../../assets/odins-logo-big.png">
                </div>
              </div><br/>
              <div class="text-center">
                <h2 style="text-align: center !important;">{{ $t('views.secure.about.Module_name') }}</h2>
              </div><br/>
              <div class="text-center">
                <div style="text-align: center !important;">{{ $t('views.secure.about.Acerca_de_version') }}: {{ moduleVersion}}</div>
              </div><br/>
              <div class="text-center">
                <div style="text-align: center !important;">{{ $t('views.secure.about.Acerca_de_desarrollado') }} <a href="http://www.odins.es/">Odin Solutions</a></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Config } from '../../config';
export default {
  name: 'about',
  data: function () {
    return {
      moduleVersion: Config.version
    };
  }
};
</script>
